import React, { useEffect, useContext, useState, useRef } from 'react'
import { Box, Hidden, CircularProgress, Button, Checkbox, TableContainer, Table, TableRow, TableHead, TableBody, TableCell, Pagination, Popover } from '@mui/material'
import { styled } from '@mui/material/styles';
import { csvFormat } from '../../../utils/csvSur' // B47 : export sans formule
import { v4 as uuidv4 } from 'uuid';
import PopupNotifContext from "../../../contexts/PopupNotifContext"
import SkeletonEcran from "./SkeletonEcran"
import NoDataScreen from "./NoDataScreen"

import Moment from 'moment'
import 'moment/locale/fr';

import APIS from "../../../utils/APIS"

import SelectEcoleMenuMobile from "./SelectEcoleMenuMobile"
import MyPopover from "../MyPopover"

import UserAdminClientContext from "../../../contexts/UserAdminClientContext"
import LanguageContext from "../../../contexts/LanguageContext"

import simpleArrowIcon from "../../../images/simpleArrowIcon.svg"
import etudiantsTotIcon from "../../../images/etudiantsTotIcon.svg"
import modulesIcon from "../../../images/modulesIcon.svg"
import tauxCompletionIcon from "../../../images/tauxCompletionIcon.svg"
import moyenneIcon from "../../../images/moyenneIcon.svg"
import softSkillsIcon from "../../../images/softSkillsIcon.svg"
import moyenneTempsIcon from "../../../images/moyenneTempsIcon.svg"
import cadrillageBGCard from "../../../images/cadrillageBGCard.svg"
import filterIcon from "../../../images/filterIcon.svg"
// Point 12 de la review du 04/08 : une icône par filtre au lieu de la même
// partout. Formes reprises de l'ancienne version, redessinées en noir et blanc.
import filtreCertificationIcon from "../../../images/filtreCertificationIcon.svg"
import filtreDiplomeIcon from "../../../images/filtreDiplomeIcon.svg"
import filtreAnneeCertifIcon from "../../../images/filtreAnneeCertifIcon.svg"
import filtreAnneeEtudeIcon from "../../../images/filtreAnneeEtudeIcon.svg"
import filtreModuleIcon from "../../../images/filtreModuleIcon.svg"
import filtreStatutIcon from "../../../images/filtreStatutIcon.svg"
import exportIcon from "../../../images/exportIcon.svg"
import searchIcon from "../../../images/searchIcon.svg"
import checkGreenRoundIcon from "../../../images/checkGreenRoundIcon.svg"
import sablierIcon from "../../../images/sablierIcon.svg"
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

import { ReactComponent as XIcon } from '../../../images/x-icon.svg'

Moment.locale('fr')

export const Header = ({ title, dataLoaded, withTuto, onClickTuto }) => {
  const {
    ecoles,
    actEcole,
    actEcoleID,
    updateActEcole,
  } = useContext(UserAdminClientContext)
  const { actLanguage, languageValues } = useContext(LanguageContext)

  return (
    <Box sx={{ marginBottom:["30px", "35px", "35px", "45px"] }}>
      <Box sx={{color:"text.blackTitle", marginBottom:"15px", fontSize:["14px", "14px", "15px", "16px"], textTransform:"capitalize"}}>
        {actEcole?.name}
      </Box>
      <Box sx={{display:"flex", gap:"10px", alignItems:"center", justifyContent:"space-between",}}>
        <Box sx={{display:"flex", gap:"8px", alignItems:"center"}}>
          <Box
            sx={{
              width:["25px", "30px", "30px", "35px"],
              minWidth:["25px", "30px", "30px", "35px"],
              cursor:"pointer",
              display:"flex",
              alignItems:"center",
              justifyContent:"center",
            }}
            onClick={() => {
              updateActEcole(actEcoleID, "home")
            }}
          >
            <img src={simpleArrowIcon} style={{width:"100%", transform:"rotate(180deg)"}}/>
          </Box>
          <Box sx={{marginLeft:"10px", fontSize:["26px", "36px", "36px", "42px"], color:"text.black"}}>
            {title}
          </Box>
        </Box>
        {withTuto &&
          <Box>
            <Hidden smDown>
              <Button
                onClick={onClickTuto ? onClickTuto : null}
                size="large"
                type="submit"
                variant="contained"
                sx={{
                  height:["45px !important", "45px !important", "45px !important", "50px !important"],
                  minHeight:["45px !important", "45px !important", "45px !important", "50px !important"],
                  fontSize:["14px", "14px", "15px", "16px"],
                  whiteSpace:"nowrap"
                }}
              >
                {languageValues?.adminDashboard?.seeTuto[actLanguage]}
              </Button>
            </Hidden>
            <Hidden smUp>
              <Button
                disableRipple
                onClick={onClickTuto ? onClickTuto : null}
                sx={{
                  fontSize:"14px",
                  color:"text.black",
                  textDecoration:"underline",
                  textUnderlineOffset: "4px",
                  minWidth:0,
                  "&:hover" : {
                    background:"transparent",
                    color:"text.subTitle",
                    textDecoration:"underline",
                  }
                }}
                size="small"
              >
                {languageValues?.adminDashboard?.seeTuto[actLanguage]}
              </Button>
            </Hidden>
          </Box>
        }
      </Box>
    </Box>
  )
}

export const CardContainer = ({icon, title, value, dataLoaded, unit, forMapping}) => {
  return (
    <Box
      sx={{
        width:
          forMapping === true ? "calc((100% / 2) - (((2 - 1) / 2) * 20px))"
          : [
            "calc((100% / 2) - (((2 - 1) / 2) * 15px))",
            "calc((100% / 3) - (((3 - 1) / 3) * 15px))",
            "calc((100% / 3) - (((3 - 1) / 3) * 15px))",
            "calc((100% / 6) - (((6 - 1) / 6) * 20px))",
          ],
        height: forMapping === true ? ["102px", "145px", "145px", "147px"] : ["102px", "130px", "130px", "130px"],
        minHeight: forMapping === true ? ["102px", "145px", "145px", "147px"] : ["102px", "130px", "130px", "130px"],
        border:"1px solid #E7E7E7",
        backgroundImage:`url(${cadrillageBGCard})`,
        backgroundRepeat:"no-repeat",
        backgroundPosition:"right 5px bottom 5px",
        backgroundColor:"white",
      }}
    >
      <Box sx={{
        width:"100%",
        height:"100%",
        background: "linear-gradient(130deg,rgba(255, 255, 255, 1) 0%, rgba(255, 255, 255, 1) 30%, rgba(255, 255, 255, 0) 95%, rgba(0, 0, 0, 0) 100%)",
      }}>
        {dataLoaded ? (
          <Box sx={{padding:["10px", "15px", "15px", "15px"], display: "flex", flexDirection:"column"}}>
            <Box sx={{display:"flex", gap:"10px", alignItems:"center", marginBottom:["7px", "12px", "12px", "8px"]}}>
              <Box
                sx={{
                  width:["25px", "30px", "30px", "35px"],
                  minWidth:["25px", "30px", "30px", "35px"],
                }}
              >
                <img src={icon} style={{width:"100%"}}/>
              </Box>
              <Box sx={{fontSize:["14px", "15px", "16px", "16px"], color:"text.subTitle", whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow:"hidden",}}>
                {title}
              </Box>
            </Box>
            <Box sx={{fontSize:["30px", "41px", "41px", "46px"], color:"black", display:"flex", alignItems:"flex-end", whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow:"hidden",}}>
              {value}
              {unit &&
                <Box sx={{fontSize:["26px", "22px", "22px", "16px"], color:"text.subTitle", paddingBottom:["3px","5px","5px","5px"], whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow:"hidden"}}>{unit}</Box>
              }
            </Box>
          </Box>
        ) : (
          <Box sx={{height:"100%", display:"flex", alignItems:"center", justifyContent:"center"}}>
            <CircularProgress size="30px" sx={{'color': 'black'}} />
          </Box>
        )}
      </Box>
    </Box>
  )
}

/* D1 review 02/09 : rond de progression de la colonne Statut (conforme Figma) */
export const RondProgression = ({ pct }) => {
  const r = 8, c = 2 * Math.PI * r
  const part = Math.max(0, Math.min(100, pct)) / 100
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" style={{flexShrink:0}}>
      <circle cx="10" cy="10" r={r} fill="none" stroke="#E7E1DC" strokeWidth="3" />
      <circle cx="10" cy="10" r={r} fill="none" stroke="#D85A30" strokeWidth="3"
        strokeDasharray={(c * part) + " " + (c * (1 - part))}
        strokeDashoffset={c / 4} strokeLinecap="round" />
    </svg>
  )
}

export const FiltersDisplay = ( { filters, setFilters, contents, defaultF, isMapping }) => {
  const {
    actEcole,
  } = useContext(UserAdminClientContext)
  const { actLanguage, languageValues } = useContext(LanguageContext)

  const [listFilters, setListFilters] = useState([])

  useEffect(() => {
    let arr = []
    for (const [key, value] of Object.entries(filters)) {
      if (value && value.length && value.length > 0) {
        if (key === "moduleIDs" && contents) {
          value.forEach((val) => {
            // 03/09 : `.find(...)` peut ne rien trouver (module retire du plan) ;
            // sans `?.` la pastille de filtre vidait l'ecran. Motif M4.
            let name = contents.find((el) => el.id === val)?.name
            arr.push({type: key, display: name || val, value : val})
          })
        } else if (key === "groupes" && actEcole?.groupes) {
          value.forEach((val) => {
            let groupe = actEcole?.groupes?.find((el) => el.groupeID === val)
            let textDisplay = groupe?.diplome || groupe?.name || val
            arr.push({type: key, display: textDisplay, value : val})
          })
        } else if (key === "campus" && actEcole?.campus) {
          value.forEach((val) => {
            let name = actEcole?.campus?.find((el) => el.id === val)?.name
            arr.push({type: key, display: name || val, value : val})
          })
        } else if (key === "moduleTypes") {
          value.forEach((val) => {
            /* B2 (retours Hicham 03/09) : le segment `contentType` etait ecrit
             * DEUX FOIS sur `enrich` et `icebreaker`. Le `?.` protege le premier,
             * pas le second : `undefined.icebreaker` levait une exception et le
             * Suivi passait a l'ecran blanc des qu'on filtrait sur ces deux
             * valeurs. Seule la branche `identif` etait correcte, d'ou un filtre
             * qui semblait marcher quand on ne testait que celle-la.
             * Cf JOURNAL-DES-ERREURS.md, motif M1. */
            let display = languageValues?.adminDashboard?.contentType?.[val]?.[actLanguage] || val
            arr.push({type: key, display: display, value : val})
          })
        } else if (key === "status") {
          value.forEach((val) => {
            let display = val
            if (val === "notStarted") {
              display = languageValues?.adminDashboard?.statusTypes?.notStarted[actLanguage]
            } else if (val === "inProgress") {
              display = languageValues?.adminDashboard?.statusTypes?.inProgress[actLanguage]
            } else if (val === "ended") {
              display = languageValues?.adminDashboard?.statusTypes?.ended[actLanguage]
            } else if (val === "endedInRat") {
              display = languageValues?.adminDashboard?.statusTypes?.endedInRat[actLanguage]
            }
            arr.push({type: key, display: display, value : val})
          })
        } else if (key === "level") {
          value.forEach((val) => {
            let display = val
            if (val === "notAcquired") {
              display = languageValues?.adminDashboard?.levelTypes?.notAcquired[actLanguage]
            } else if (val === "inProgress") {
              display = languageValues?.adminDashboard?.statusTypes?.inProgress[actLanguage]
            } else if (val === "acquired") {
              display = languageValues?.adminDashboard?.levelTypes?.acquired[actLanguage]
            } else if (val === "rattrapage") {
              display = languageValues?.adminDashboard?.levelTypes?.rattrapage[actLanguage]
            }
            arr.push({type: key, display: display, value : val})
          })
        } else {
          value.forEach((val) => {
            arr.push({type: key, display: val, value : val})
          })
        }
      }
    }

    setListFilters(arr)
  }, [filters])
  return (
    <Box sx={{display:"flex", gap:"15px", flexWrap:"wrap", marginTop:"7px"}}>
      {listFilters.map((elem, index) => {
        let canDelete = true
        if (isMapping === true) {
          if (elem.type === "groupes") {
            canDelete = false
          }
        }

        return (
          <Box
            key={index}
            sx={{
              display:"flex",
              alignItems:"center",
              gap:"5px",
              cursor:canDelete&&"pointer",
              userSelect:"none",
              color:canDelete===false ? "text.black" : "text.subTitle",
              "&:hover" : {
                color:"text.black",
              }
            }}
            onClick={(e) => {
              if (canDelete === true) {
                setFilters({...filters,
                  [elem.type] : filters[elem.type].filter(a =>
                    a !== elem.value
                  )
                });
              }
            }}
          >
            <Box sx={{
              height:"25px",
              fontSize:"13px",
              background:"white",
              borderRadius:"0px",
              border:"1px dashed #E7E7E7",
              padding:"5px 8px",
              display:"flex",
              alignItems:"center"
            }}>
              {elem.display}
            </Box>
            {canDelete === true &&
              <Box>
                <XIcon />
              </Box>
            }
          </Box>
        )
      })}
      {listFilters.length > 0 &&
        <Box
          sx={{
            cursor:"pointer",
            display:isMapping === true ? listFilters?.some((el) => el.type !== "groupes") ? "flex" : "none" : "flex",
            alignItems:"center",
            fontSize:"12px",
            color:"text.subTitle",
            textDecoration:"underline",
            textUnderlineOffset: "3px",
            userSelect:"none",
            '&:hover': {
              color:"text.black"
            },
          }}
          onClick={(e) => {
            if (isMapping === true) {
              let newFilters = JSON.parse(JSON.stringify(defaultF))
              newFilters.groupes = filters.groupes
              setFilters(newFilters)
            } else {
              setFilters(defaultF)
            }
          }}
        >
          {languageValues?.adminDashboard?.filters?.deleteAll[actLanguage]}
        </Box>
      }
    </Box>
  )
}

const ActionList = ({ glbData, filters, setFilters, icebreakerQuestions }) => {
  const {
    actEcole,
  } = useContext(UserAdminClientContext)
  const { actLanguage, languageValues } = useContext(LanguageContext)

  const [actItem, setActItem] = useState(null)
  const menuOpenClose = (item) => {
    if (item === actItem) {
      setActItem(null)
    } else {
      setActItem(item)
    }
  }

  return (
    <Box sx={{display:"flex", alignItems:"flex-start"}}>
      <Box sx={{
        minWidth:"220px",
        maxWidth:"350px",
        padding:"10px 20px",
        boxShadow: "0 0 20px 0 rgba(0, 0, 0, 0.15)",
        border: "1px solid black",
        background:"white",
      }}>
        {actEcole?.groupes?.length > 1 &&
          <>
            <ItemPopover
              title={languageValues?.adminDashboard?.filters?.groupe[actLanguage]}
              onClick={() => {menuOpenClose("groupe")}} selected={actItem === "groupe"} icon={filtreCertificationIcon}
            />
            <Hidden mdUp>
              {actItem === "groupe" &&
                <FilterList
                  title={languageValues?.adminDashboard?.filters?.groupeSub[actLanguage]}
                  datas={actEcole?.groupes} dataToDisplay={["diplome", "name"]} dataToCheck="groupeID" filterType="groupes" filters={filters} setFilters={setFilters}
                />
              }
            </Hidden>
          </>
        }
        {icebreakerQuestions?.secteurs === true &&
          <>
            <ItemPopover
              title={languageValues?.adminDashboard?.filters?.sector[actLanguage]}
              onClick={() => {menuOpenClose("secteur")}} selected={actItem === "secteur"} icon={filtreDiplomeIcon}
            />
            <Hidden mdUp>
              {actItem === "secteur" &&
                <FilterList
                  title={languageValues?.adminDashboard?.filters?.sectorSub[actLanguage]}
                  datas={icebreakerQuestions.secteursReps} filterType="secteur" filters={filters} setFilters={setFilters}
                />
              }
            </Hidden>
          </>
        }
        {actEcole?.campus?.length > 1 &&
          <>
            <ItemPopover
              title={languageValues?.adminDashboard?.filters?.campus[actLanguage]}
              onClick={() => {menuOpenClose("campus")}} selected={actItem === "campus"} icon={filterIcon}
            />
            <Hidden mdUp>
              {actItem === "campus" &&
                <FilterList
                  title={languageValues?.adminDashboard?.filters?.campusSub[actLanguage]}
                  datas={actEcole?.campus} dataToDisplay={"name"} dataToCheck="id" filterType="campus" filters={filters} setFilters={setFilters}
                />
              }
            </Hidden>
          </>
        }
        {icebreakerQuestions?.diplome === true &&
          <>
            <ItemPopover
              title={languageValues?.adminDashboard?.filters?.graduationYear[actLanguage]}
              onClick={() => {menuOpenClose("diplome")}} selected={actItem === "diplome"} icon={filtreAnneeCertifIcon}
            />
            <Hidden mdUp>
              {actItem === "diplome" &&
                <FilterList
                  title={languageValues?.adminDashboard?.filters?.graduationYearSub[actLanguage]}
                  /* Motif M16, jumeau de S1 (03/09) : ce menu compare `nomDiplome`
                     — « Master », « BUT », « Licence professionnelle » — et on lui
                     donnait la liste des reponses ANNEE D'ETUDE. Choisir une valeur
                     ne pouvait donc jamais rien renvoyer. Le defaut etait invisible
                     tant que le menu s'appelait « Annee de certification » ; il
                     saute aux yeux maintenant qu'il s'appelle « Diplome ».
                     Progression.js passait deja `diplomeReps`. */
                  datas={icebreakerQuestions.diplomeReps} filterType="anneesDiplome" filters={filters} setFilters={setFilters}
                />
              }
            </Hidden>
          </>
        }
        {icebreakerQuestions?.annees === true &&
          <>
            <ItemPopover
              title={languageValues?.adminDashboard?.filters?.studyYear[actLanguage]}
              onClick={() => {menuOpenClose("etude")}} selected={actItem === "etude"} icon={filtreAnneeEtudeIcon}
            />
            <Hidden mdUp>
              {actItem === "etude" &&
                <FilterList
                  title={languageValues?.adminDashboard?.filters?.studyYearSub[actLanguage]}
                  datas={icebreakerQuestions.anneesReps} filterType="anneesEtude" filters={filters} setFilters={setFilters}   /* S1 : annees, pas diplomes */
                />
              }
            </Hidden>
          </>
        }
        <ItemPopover
          title={languageValues?.adminDashboard?.filters?.moduleType[actLanguage]}
          onClick={() => {menuOpenClose("type")}} selected={actItem === "type"} icon={filtreModuleIcon}
        />
        <Hidden mdUp>
          {actItem === "type" &&
            <FilterList
              title={languageValues?.adminDashboard?.filters?.moduleTypeSub[actLanguage]}
              datas={contentsTypes} filterType="moduleTypes" filters={filters} setFilters={setFilters}
            />
          }
        </Hidden>
        <ItemPopover
          title={languageValues?.adminDashboard?.filters?.moduleName[actLanguage]}
          onClick={() => {menuOpenClose("nom")}} selected={actItem === "nom"} icon={filtreModuleIcon}
        />
        <Hidden mdUp>
          {actItem === "nom" &&
            <FilterList
              title={languageValues?.adminDashboard?.filters?.moduleNameSub[actLanguage]}
              datas={glbData.contents} dataToDisplay="name" dataToCheck="id" filterType="moduleIDs" filters={filters} setFilters={setFilters}
            />
          }
        </Hidden>
        <ItemPopover
          title={languageValues?.adminDashboard?.filters?.status[actLanguage]}
          onClick={() => {menuOpenClose("status")}} selected={actItem === "status"} icon={filtreStatutIcon}
        />
        <Hidden mdUp>
          {actItem === "status" &&
            <FilterList
              title={languageValues?.adminDashboard?.filters?.statusSub[actLanguage]}
              datas={statusTypes} filterType="status" filters={filters} setFilters={setFilters}
            />
          }
        </Hidden>
      </Box>
      <Hidden mdDown>
        {actItem !== null &&
          <Box sx={{
            marginLeft:"10px",
            maxWidth:"350px",
            minWidth:"200px",
            padding:"10px 20px",
            boxShadow: "0 0 20px 0 rgba(0, 0, 0, 0.15)",
            border: "1px solid black",
            background:"white",
          }}>
            {actItem === "nom" &&
              <FilterList
                title={languageValues?.adminDashboard?.filters?.moduleNameSub[actLanguage]}
                datas={glbData.contents} dataToDisplay="name" dataToCheck="id" filterType="moduleIDs" filters={filters} setFilters={setFilters}
              />
            }
            {actItem === "type" &&
              <FilterList
                title={languageValues?.adminDashboard?.filters?.moduleTypeSub[actLanguage]}
                datas={contentsTypes} filterType="moduleTypes" filters={filters} setFilters={setFilters}
              />
            }
            {actItem === "groupe" &&
              <FilterList
                title={languageValues?.adminDashboard?.filters?.groupeSub[actLanguage]}
                datas={actEcole?.groupes} dataToDisplay={["diplome", "name"]} dataToCheck="groupeID" filterType="groupes" filters={filters} setFilters={setFilters}
              />
            }
            {actItem === "campus" &&
              <FilterList
                title={languageValues?.adminDashboard?.filters?.campusSub[actLanguage]}
                datas={actEcole?.campus} dataToDisplay={"name"} dataToCheck="id" filterType="campus" filters={filters} setFilters={setFilters}
              />
            }
            {actItem === "secteur" &&
              <FilterList
                title={languageValues?.adminDashboard?.filters?.sectorSub[actLanguage]}
                datas={icebreakerQuestions.secteursReps} filterType="secteur" filters={filters} setFilters={setFilters}
              />
            }
            {actItem === "etude" &&
              <FilterList
                title={languageValues?.adminDashboard?.filters?.studyYearSub[actLanguage]}
                datas={icebreakerQuestions.anneesReps} filterType="anneesEtude" filters={filters} setFilters={setFilters}   /* S1 : annees, pas diplomes */
              />
            }
            {actItem === "diplome" &&
              <FilterList
                title={languageValues?.adminDashboard?.filters?.graduationYearSub[actLanguage]}
                datas={icebreakerQuestions.diplomeReps} filterType="anneesDiplome" filters={filters} setFilters={setFilters}   /* M16 : diplomes, pas annees */
              />
            }
            {actItem === "status" &&
              <FilterList
                title={languageValues?.adminDashboard?.filters?.statusSub[actLanguage]}
                datas={statusTypes} filterType="status" filters={filters} setFilters={setFilters}
              />
            }
          </Box>
        }
      </Hidden>
    </Box>
  )
}

export const ItemPopover = ({ icon, title, onClick, selected }) => {
  return (
    <Box
      sx={{
        display:"flex",
        alignItems:"center",
        justifyContent:"space-between",
        color:selected ? "text.black" : "text.subTitle",
        fontSize:"14px",
        height:"35px",
        cursor:"pointer",
        '&:hover': {
          color:"text.black"
        },
      }}
      onClick={onClick}
    >
      <Box sx={{display:"flex", alignItems:"center", gap:"10px"}} >
        <Box sx={{width:'17px', height:"100%", display:"flex", alignItems:"center"}}>
          <img src={icon} style={{width:"100%"}} />
        </Box>
        <Box>{title}</Box>
      </Box>
      <Hidden mdUp>
        <KeyboardArrowDownIcon />
      </Hidden>
      <Hidden mdDown>
        <KeyboardArrowDownIcon style={{transform: "rotate(-90deg)"}}/>
      </Hidden>
    </Box>
  )
}

/* D9 review 02/09 : filtres en menus deroulants EN LIGNE (conforme Figma),
 * a la place du bouton « Selectionner Filtres » sur grand ecran. Chaque menu
 * reutilise FilterList tel quel, dans un Popover ancre sur son bouton. */
export const FiltresInline = ({ menus, filters, setFilters }) => {
  const [menuOuvert, setMenuOuvert] = useState(null)   // cle du menu ouvert
  const [ancre, setAncre] = useState(null)
  const nbActifs = (filterType) => (filters?.[filterType] || []).length
  return (
    <Box sx={{display:"flex", gap:"8px", flexWrap:"wrap", alignItems:"center"}}>
      {menus.map((menu) => (
        <React.Fragment key={menu.cle}>
          <Box
            onClick={(e) => {
              if (menuOuvert === menu.cle) { setMenuOuvert(null); setAncre(null) }
              else { setMenuOuvert(menu.cle); setAncre(e.currentTarget) }
            }}
            sx={{
              display:"flex", alignItems:"center", gap:"7px",
              height:"40px", padding:"0 12px",
              background:"white",
              border: nbActifs(menu.filterType) > 0 ? "1px solid black" : "1px solid #E7E7E7",
              borderRadius:"4px",
              fontSize:"14px", cursor:"pointer", userSelect:"none",
              whiteSpace:"nowrap",
              '&:hover': { border:"1px solid black" },
            }}
          >
            {menu.titre}
            {nbActifs(menu.filterType) > 0 && <Box component="span" sx={{fontSize:"12px", background:"black", color:"white", borderRadius:"10px", padding:"1px 7px"}}>{nbActifs(menu.filterType)}</Box>}
            <Box component="span" sx={{fontSize:"10px", color:"#545455"}}>{'\u25BC'}</Box>
          </Box>
          <Popover
            open={menuOuvert === menu.cle}
            anchorEl={ancre}
            onClose={() => { setMenuOuvert(null); setAncre(null) }}
            anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
            transformOrigin={{ vertical: "top", horizontal: "left" }}
          >
            <Box sx={{padding:"10px 16px", minWidth:"210px", maxHeight:"320px", overflowY:"auto"}}>
              <FilterList
                title={menu.sousTitre}
                datas={menu.datas} dataToDisplay={menu.dataToDisplay} dataToCheck={menu.dataToCheck}
                filterType={menu.filterType} filters={filters} setFilters={setFilters}
              />
            </Box>
          </Popover>
        </React.Fragment>
      ))}
    </Box>
  )
}

export const FilterList = ({ title, filters, setFilters, datas, filterType, dataToDisplay, dataToCheck, onlyOneSelection }) => {
  const { actLanguage, languageValues } = useContext(LanguageContext)

  let datasUniques = []
  if (filterType === "groupes") {
    datasUniques = [...new Set(datas)].sort((a, b) => {
      let textA = ""
      if (a.diplome) { textA = a.diplome } else { textA = a.name }
      let textB = ""
      if (b.diplome) { textB = b.diplome } else { textB = b.name }
      return textA.localeCompare(textB)
    })
  } else if (filterType === "secteur") {
    datas.map((x) => {
      datasUniques.push(x.trim())
    })
    datasUniques = [...new Set(datasUniques)].sort()
  } else if (filterType === "secteur") {
    datas.map((x) => {
      datasUniques.push(x.trim())
    })
    datasUniques = [...new Set(datasUniques)].sort()
  } else if (filterType === "diplome") {
    datas.map((x) => {
      datasUniques.push(x.trim())
    })
    datasUniques = [...new Set(datasUniques)].sort()
  } else if (filterType === "etude") {
    datasUniques = [...new Set(datas)].sort((a, b) => {
      return a.name.localeCompare(b.name)
    })
  } else if (filterType === "moduleIDs") {
    datas.forEach((x) => {
      let find = datasUniques.find((el) => el.id === x.id)
      if (!find) {
        datasUniques.push(x)
      }
    })
    datasUniques = [...new Set(datasUniques)].sort((a, b) => {
      return a.name.localeCompare(b.name)
    })
  } else {
    datasUniques = [...datas]
  }

  return (
    <Box>
      <Hidden mdDown>
        <Box sx={{display:"flex", height:"40px", alignItems:"center", justifyContent:"space-between", gap:"5px"}}>
          <Box sx={{fontSize:"14px", color:"black"}}>
            {title}
          </Box>
          <Box
            sx={{
              cursor:"pointer",
              fontSize:"12px",
              textDecoration :"underline",
              textUnderlineOffset: "3px",
              color: "text.subTitle",
              userSelect:"none",
              '&:hover': {
                color:"text.black"
              },
              display:onlyOneSelection ? "none" : "block",
            }}
            onClick={() => {
              setFilters({...filters,
                [filterType] : []
              });
            }}
          >
            {languageValues?.adminDashboard?.filters?.delete[actLanguage]}
          </Box>
        </Box>
      </Hidden>
      <Box sx={{
        maxHeight:'300px',
        overflowX:"auto",
        scrollbarColor: "#FAF8F6 transparent",
        marginLeft:"10px",
        paddingLeft:"10px",
        marginBottom:["15px", "15px", "10px", "10px"],
        marginTop:["5px", "5px", "0px", "0px"],
        borderLeft:"1px solid rgba(74, 74, 74, 0.2)"
      }}>
        {datasUniques.map((elem, i) => {
          let valueToCheck = null
          if (dataToCheck) {
            valueToCheck = elem[dataToCheck]
          } else {
            valueToCheck = elem
          }
          let checked = filters[filterType].includes(valueToCheck)
          return (
            <Box
              key={i}
              sx={{
                cursor:"pointer",
                padding:"5px 0px",
                display:"flex",
                alignItems:"center",
                gap:"5px",
                color:checked ? "text.black" : "text.subTitle",
                '&:hover': {
                  color:"text.black"
                },
              }}
              onClick={(e) => {
                if (onlyOneSelection === true) {
                  if (checked) {
                    /*setFilters({...filters,
                      [filterType] : []
                    });*/
                  } else {
                    setFilters({...filters,
                      [filterType] : [valueToCheck]
                    });
                  }
                } else {
                  if (checked) {
                    setFilters({...filters,
                      [filterType] : filters[filterType].filter(a =>
                        a !== valueToCheck
                      )
                    });
                  } else {
                    setFilters({...filters,
                      [filterType] : [...filters[filterType], valueToCheck]
                    });
                  }
                }
              }}
            >
              <Checkbox
                checked={checked}
                sx={{
                  padding:0,
                  color:'rgba(206, 206, 206, 0.5)',
                  '&.Mui-checked' : {
                    color:"text.black",
                  }
                }}
                disableRipple
              />
              <Box sx={{
                whiteSpace: 'nowrap',
                textOverflow: 'ellipsis',
                overflow:"hidden",
                fontSize:"13px",

              }}>
                {(filterType !== "moduleTypes" && filterType !== "status" && filterType !== "level") ? (
                  <>
                    {getDisplayValueForFilterList(elem, dataToDisplay)}
                  </>
                ) : (
                  <>
                    {elem === 'identif' && languageValues?.adminDashboard?.contentType?.identif[actLanguage]}
                    {elem === 'enrich' && languageValues?.adminDashboard?.contentType?.enrich[actLanguage]}
                    {elem === 'icebreaker' && languageValues?.adminDashboard?.contentType?.icebreaker[actLanguage]}

                    {elem === 'notStarted' && languageValues?.adminDashboard?.statusTypes?.notStarted[actLanguage]}
                    {elem === 'inProgress' && languageValues?.adminDashboard?.statusTypes?.inProgress[actLanguage]}
                    {elem === 'ended' && languageValues?.adminDashboard?.statusTypes?.ended[actLanguage]}
                    {elem === 'endedInRat' && languageValues?.adminDashboard?.statusTypes?.endedInRat[actLanguage]}

                    {elem === 'notAcquired' && languageValues?.adminDashboard?.levelTypes?.notAcquired[actLanguage]}
                    {elem === 'acquired' && languageValues?.adminDashboard?.levelTypes?.acquired[actLanguage]}
                    {elem === 'rattrapage' && languageValues?.adminDashboard?.levelTypes?.rattrapage[actLanguage]}
                  </>
                )}
              </Box>
            </Box>
          )
        })}
      </Box>
    </Box>
  )
}

const getDisplayValueForFilterList = (elem, dataToDisplay) => {
  if (dataToDisplay) {
    if (typeof(dataToDisplay) === "string") {
      return elem[dataToDisplay]
    } else if (typeof(dataToDisplay) === "object") {
      for (let i=0; i<dataToDisplay.length; i++) {
        if (elem[dataToDisplay[i]]) {
          return elem[dataToDisplay[i]]
        }
      }
    }
  } else {
    return elem
  }
}


let defautFilters = {
  moduleIDs : [],
  moduleTypes : [],
  groupes : [],
  campus : [],
  anneesEtude : [],
  anneesDiplome : [],
  secteur : [],
  status : [],
}
let contentsTypes = ['icebreaker', 'identif', 'enrich']
let statusTypes = ['notStarted', 'inProgress', 'ended'/* ,'endedInRat'*/]

/* S3 (retours Hicham 03/09) — l'etat d'un APPRENANT, pas d'une ligne.
 *
 * Le tableau affiche une ligne par apprenant, depliable en lignes
 * apprenant x module. Le statut, lui, est porte par la ligne : un apprenant a
 * 25 % a une ligne « termine » et trois lignes « pas commence », et AUCUNE
 * ligne « en cours ». Filtrer sur « En cours » le faisait donc disparaitre,
 * pendant qu'il apparaissait a la fois sous « Termine » et sous
 * « Pas commence » — avec, en prime, un « 1/1 modules » mensonger, puisque le
 * filtre avait retire ses autres lignes.
 *
 * L'etat agrege se lit comme le client le lit dans la colonne « Statut » :
 *   - tout est termine            -> termine (rattrapage s'il y en a eu un)
 *   - rien n'est commence         -> pas commence
 *   - le reste, quel qu'il soit   -> en cours
 *
 * Exporte pour etre controlable sans monter l'ecran.
 */
export const statutAgrege = (lignes) => {
  const l = Array.isArray(lignes) ? lignes : []
  if (l.length === 0) { return "notStarted" }
  const termines = l.filter((x) => x?.status === "ended")
  if (termines.length === l.length) {
    return termines.some((x) => x?.endedInRat === true) ? "endedInRat" : "ended"
  }
  if (l.every((x) => x?.status === "notStarted")) { return "notStarted" }
  return "inProgress"
}

/* S2 (fiche V3 de Nawal, 03/09) : largeurs des colonnes du tableau de suivi.
   Elles sont posees une fois, sur l'EN-TETE, et le corps s'y aligne parce que
   la table est en `table-layout: fixed`. Sans elles, chaque filtre redessinait
   les colonnes selon le texte le plus long affiche a ce moment-la.

   03/09, correctif — POURQUOI DES POURCENTAGES ET PLUS DES PIXELS.
   La premiere version posait des largeurs fixes et laissait « Nom » sans
   largeur, pour qu'elle absorbe le reste. Les huit colonnes fixes totalisent
   1530 px : des qu'une ecole les affiche toutes, il ne reste RIEN pour « Nom »
   sur un ecran de 1440 px. Mesure sur l'ecole 2 (« test ecole 22 »), la seule
   qui rende les huit : « Nom » tombait de 182 px a 0, avec 81 px de
   debordement a 1440 px et 241 px a 1280 px. La demo Saclay n'a que six
   colonnes, c'est pourquoi le controle ne voyait rien.

   En pourcentages, le navigateur RENORMALISE : quel que soit le sous-ensemble
   de colonnes conditionnelles rendu, chacune garde sa part relative et aucune
   ne peut valoir zero. « Nom » a donc desormais sa propre largeur, la plus
   grande. La stabilite sous filtrage que visait S2 est conservee : une part
   relative ne depend pas plus du contenu qu'une largeur fixe.

   Ces nombres n'ont pas besoin de sommer a 100 : ils se lisent comme des poids.
   Avec les neuf colonnes ils font 131, « Nom » vaut alors 22/131 ; avec les six
   de Saclay ils font 93, « Nom » vaut 22/93. Jamais moins de 16 %. */
const LARGEUR_COL = {
  nom           : "22%",
  certification : "14%",
  nomDiplome    : "16%",
  campus        : "12%",
  anneeCertif   : "12%",
  anneeEtude    : "13%",
  typeModule    : "14%",
  module        : "13%",
  statut        : "15%",
}

const Suivi = ({ }) => {

  const {
    ecoles,
    actEcole,
  } = useContext(UserAdminClientContext)
  const { actLanguage, languageValues } = useContext(LanguageContext)


  const [dataLoaded, setDataLoaded] = useState(false)
  // Relecture 02/09 : sans cet etat, une ecole sans module exploitable laissait
  // le squelette E5 pulser indefiniment (meme piege que E2 sur les autres ecrans)
  const [aucuneDonnee, setAucuneDonnee] = useState(false)
  // Relecture finale 02/09 : distinguer « rien a montrer » de « serveur muet »
  const [reseauCoupe, setReseauCoupe] = useState(false)
  const [glbData, setGlbData] = useState(null)
  const [filteredData, setFilteredData] = useState([])
  const [filteredStat, setFilteredStat] = useState({})
  const [filters, setFilters] = useState(defautFilters)

  const [nbrPage, setNbrPage] = useState(1)
  const [page, setPage] = useState(1)

  const [popoverFilters, setPopoverFilters] = useState(false)
  // E3 review 02/09 : recherche d'un apprenant par son nom
  const [recherche, setRecherche] = useState("")
  const popoverRef = useRef()

  useEffect(() => {
    setDataLoaded(false)
    if (actEcole?.groupes?.length > 0) {
      let fetchData = []
      let icebreakerIDs = []
      if (checkIfHaveRat() === true) {
        statusTypes = ['notStarted', 'inProgress', 'ended' ,'endedInRat']
      } else {
        statusTypes = ['notStarted', 'inProgress', 'ended']
      }
      actEcole?.groupes?.forEach((g) => {
        if (g.icebreaker !== null) {
          let ids = []
          if (g?.icebreaker) {
            ids.push(g?.icebreaker)
            icebreakerIDs.push(g?.icebreaker)
          }
          g?.plan?.plan?.forEach((p) => {
            ids.push(p.id)
          })
          fetchData.push({
            groupeID : g.groupeID,
            ids : ids,
            icebreaker : g.icebreaker
          })
        }
      })
      if (fetchData.length === 0) {
        setAucuneDonnee(true)
      } else {
        setAucuneDonnee(false)
        setReseauCoupe(false)
      }
      if (fetchData.length > 0) {
        APIS.clientAdminSuivi({fetchData : fetchData}).then((result) => {
            if (result?.value?.length > 0) {
              let finalData = {
                contents : [],
                results : [],
                users : [],
                nbrUsersTotal : 0
              }
              result?.value?.forEach((d) => {
                if (d.isOk === true && d.contents && d.results) {
                  //on rechercher les résultats pour chaque user
                  d.users.forEach((user) => {
                    d.contents.forEach((content) => {
                      let find = d.results.find((el) => el.contentID === content.id && el.userID === user.id)
                      if (!find) {
                        d.results.push({
                          campusID : user.campusID,
                          groupeID : d.groupeID,
                          contentID : content.id,
                          userID : user.id,
                          name : user.name,
                          icebreakerResults : user.icebreakerResults,
                          isDone : 0,
                          isDoneInRat : 0,
                          progress : 0,
                        })
                      } else {
                        find.groupeID = d.groupeID
                        find.campusID = user.campusID
                      }
                    });
                  })

                  finalData.nbrUsersTotal += d.nbrUsersTotal

                  d.contents.forEach((content) => {
                    content.groupeID = d?.groupeID
                    finalData.contents.push(content)
                  })
                  d.users.forEach((user) => {
                    finalData.users.push(user)
                  })
                  d.results.forEach((result) => {
                    finalData.results.push(result)
                  })
                }
              })

              let finalContentsFiltered = []
              finalData?.contents?.forEach((content) => {
                let find = finalContentsFiltered.find((el) => el.id === content.id)
                if (find) {
                  if (content.groupeID) {
                    find.groupeIDs.push(content.groupeID)
                  }
                } else {
                  let newContent = {...content}
                  newContent.groupeIDs = []
                  if (content.groupeID) { newContent?.groupeIDs?.push(content.groupeID)}
                  delete newContent.groupeID
                  finalContentsFiltered.push(newContent)
                }
              })

              finalData.contents = finalContentsFiltered
              finalData.icebreakerIDs = icebreakerIDs

              setGlbData(finalData)
              setDataLoaded(true)
            } else {
              setDataLoaded(false)
              setAucuneDonnee(true) // Relecture 02/09 (bis) : reponse vide = pas de donnees
              setReseauCoupe(result?.reseauIndisponible === true)
            }
          })
      }
    } else {
      // Relecture 02/09 (bis) : ecole sans aucun groupe, sinon chargement sans fin
      setAucuneDonnee(true)
    }
  }, [actEcole])

  useEffect(() => {
    if (glbData !== null) {
      let newArr = []
      if (glbData.contents && glbData.contents.length > 0 && glbData.results && glbData.results.length > 0) {
        glbData.contents.forEach((content) => {
          content.softSkills = content.softSkills?.filter((el) => el.value === 'oui')
        });
        glbData.results.forEach((res) => {
          let scoreGlobale = 0;
          if (res.resultFin?.glbMaster?.score) {
            scoreGlobale = res.resultFin.glbMaster.score
          } else if (res.resultFin?.master?.score) {
            scoreGlobale = res.resultFin.master.score
          }
          let isIcebreakerResult = glbData?.icebreakerIDs?.includes(res?.contentID)
          let obj = {
            userName : res.name,
            userID : res.userID,
            contentID : res.contentID,
            groupeID : res.groupeID,
            campusID : res.campusID,
            // 03/09 : un resultat dont le contenu n'est plus dans le plan vidait
            // l'ecran ici. Motif M4 du journal des erreurs.
            contentName : glbData.contents.find((el) => el.id === res.contentID)?.name || "-",
            contentType : glbData.contents.find((el) => el.id === res.contentID)?.type || null,
            // Point 3 de la review du 04/08 : les trois reponses de l'icebreaker
            // tombaient dans les mauvaises colonnes. Verifie sur les donnees
            // reelles, les questions posees sont :
            //   secteurs -> « Quel est votre secteur ? »        (ex. Droit)
            //   annees   -> « Quelle est votre annee d'etude ? » (ex. 5e annee)
            //   diplome  -> « Quel est votre niveau de diplome ? » (ex. Master)
            // On les nomme donc d'apres ce qu'elles contiennent vraiment.
            anneeEtude : res.icebreakerResults?.annees || null,
            nomDiplome : res.icebreakerResults?.diplome || null,
            secteur : res.icebreakerResults?.secteurs || null,
            scoreGlobale : scoreGlobale,
            updatedAt : res.updatedAt,
            progress : res.progress,
            status : (res.progress == 100 && res.isDone == 1) ? "ended" : res.progress > 0 ? "inProgress" : "notStarted",
            endedInRat : res.isDoneInRat == 1 ? true : false,
            isIcebreakerResult : isIcebreakerResult
          }
          //console.log(obj)
          newArr.push(obj)
        })
      }

      //for TEST
      /*let testArr = []
      for(let i=0; i<48; i++) {
        if (newArr[0]) { testArr.push(newArr[0]) }
        if (newArr[1]) { testArr.push(newArr[1]) }
      }
      newArr = testArr*/

      //filtered
      if (filters.moduleIDs.length !== 0) {
        newArr = newArr.filter((el) => {
          return filters.moduleIDs.includes(el.contentID)
        })
      }
      if (filters.moduleTypes.length !== 0) {
        newArr = newArr.filter((el) => {
          return filters.moduleTypes.includes(el.contentType)
        })
      }
      if (filters.campus.length !== 0) {
        newArr = newArr.filter((el) => {
          return filters.campus.includes(el.campusID)
        })
      }
      if (filters.groupes.length !== 0) {
        newArr = newArr.filter((el) => {
          return filters.groupes.includes(el.groupeID)
        })
      }
      if (filters.secteur.length !== 0) {
        newArr = newArr.filter((el) => {
          return filters.secteur.includes(el.secteur)
        })
      }
      if (filters.anneesEtude.length !== 0) {
        newArr = newArr.filter((el) => {
          return filters.anneesEtude.includes(el.anneeEtude)
        })
      }
      if (filters.anneesDiplome.length !== 0) {
        // Ce filtre porte sur le niveau de diplome (cf point 3 du 04/08).
        newArr = newArr.filter((el) => {
          return filters.anneesDiplome.includes(el.nomDiplome)
        })
      }
      /* S3 : ce filtre comparait le statut de CHAQUE LIGNE. On regroupe d'abord
         les lignes par apprenant, on en deduit son etat d'ensemble, et on garde
         ou on ecarte l'apprenant EN ENTIER. Deux consequences voulues : un
         apprenant partiellement avance ressort bien sous « En cours », et les
         lignes qu'on lui garde restent toutes les siennes, donc son
         « N/M modules » continue de dire la verite. */
      if (filters.status.length !== 0) {
        const lignesParUser = new Map()
        newArr.forEach((el) => {
          if (!lignesParUser.has(el.userID)) { lignesParUser.set(el.userID, []) }
          lignesParUser.get(el.userID).push(el)
        })
        const usersGardes = new Set()
        lignesParUser.forEach((lignes, userID) => {
          if (filters.status.includes(statutAgrege(lignes))) { usersGardes.add(userID) }
        })
        newArr = newArr.filter((el) => usersGardes.has(el.userID))
      }

      let additionScore = 0;
      newArr.forEach((res) => {
        if (res.status === "ended" && res.isIcebreakerResult !== true) {
          additionScore+=parseInt(res.scoreGlobale)
        }
      })
      //let softSkills = 0;
      let softSkillsArr = []
      let uniqueSoftSkills = []
      let timing = 0;
      let nbrModules = 0
      let completion = 0;
      if (filters.moduleIDs.length === 0 && filters.moduleTypes.length === 0 && filters.groupes.length === 0) {
        glbData.contents.forEach((content) => {
          nbrModules+= 1
          if (content.softSkills && content.softSkills?.length > 0) {
            content.softSkills.forEach((skill) => {
              softSkillsArr.push(skill)
            })
          }
          timing += content.timing
        })
      } else {
        let contentsCopy = JSON.parse(JSON.stringify(glbData.contents))
        if (filters.moduleIDs.length !== 0) {
          contentsCopy = contentsCopy.filter((el) => {
            return filters.moduleIDs.includes(el.id)
          })
        }
        if (filters.moduleTypes.length !== 0) {
          contentsCopy = contentsCopy.filter((el) => {
            return filters.moduleTypes.includes(el.type)
          })
        }
        if (filters.groupes.length !== 0) {
          contentsCopy = contentsCopy.filter((el) => {
            for (let i=0; i<filters?.groupes?.length; i++) {
              if (el?.groupeIDs?.includes(filters?.groupes[i])) {
                return true
                break
              }
            }
          })
        }
        contentsCopy.forEach((content) => {
          nbrModules+= 1
          if (content.softSkills && content.softSkills?.length > 0) {
            content.softSkills.forEach((skill) => {
              softSkillsArr.push(skill)
            })
          }
          timing += content.timing
        })
      }

      //on trie par ordre alphabétiques
      newArr = newArr.sort((a,b)=>a.userName.localeCompare(b.userName))



      if (newArr.length === 0) {
        completion = "-"
      } else {
        completion = (newArr.filter((el) => el.status === "ended").length / newArr.length ) * 100
        //completion =  Math.round( (completion) *100 )/100+"%"
        //completion = (newArr.length / (glbData.nbrUsersTotal * nbrModules)) * 100
        completion = Math.round(completion)+"%"
      }

      //on enlève les doublons de softskills
      softSkillsArr.forEach((skill) => {
        let find = uniqueSoftSkills.find((el) => el.key === skill.key)
        if (!find) {
          uniqueSoftSkills.push(skill)
        }
      })

      //calcul de la moyenne

      let newStat = {
        etudiantTot : glbData.nbrUsersTotal,
        modules : nbrModules,
        tauxCompletion : completion,
        //moyenne : newArr.length === 0 ? "-" : Math.round( (additionScore/newArr.length) *100 )/100,
        moyenne : newArr.filter((el) => el.status === "ended" && el.isIcebreakerResult !== true).length === 0 ? "-" : Math.round(additionScore/newArr.filter((el) => el.status === "ended" && el.isIcebreakerResult !== true).length),
        softSkills : uniqueSoftSkills?.length,
        // Point 6 de la review du 04/08 : cette carte s'intitule « Temps moyen »
        // mais affichait la SOMME des durées des modules, quand l'écran
        // Progression affichait bien la moyenne (60 min ici, 20 min là).
        // A3 review 02/09 : « Temps moyen passe » = SOMME des durees des modules
        // (reference historique : Average time spent 175 MIN = cumul de tous les
        // modules, icebreaker inclus). La division par module donnait une valeur
        // differente de celle de Progression, et fausse.
        timing : Math.round(timing),
      }


      setNbrPage(Math.ceil(newArr.length/25))
      setPage(1)

      //console.log(newArr)
      setFilteredData(newArr)
      setFilteredStat(newStat)
    }
  }, [glbData, filters])

  const { addPopupNotif } = useContext(PopupNotifContext)  // E6 : toast d'export
  const handleExport = () => {
    let filename = 'Export '+languageValues?.adminDashboard?.monitoring[actLanguage]+' ' + actEcole?.name + ', ' + Moment().format('DD/MM/YYYY') + ', ' + Moment().format('HH')+'h'+Moment().format('mm')
    const renameKeys = (keysMap, objs) => {
      for (let i=0; i<objs.length;i++) {
        let obj = objs[i]
        objs[i] = Object.keys(obj).reduce(
        (acc, key) => ({
            ...acc,
            ...{ [keysMap[key] || key]: obj[key] }
        }),
        {})
      }
      return objs
    }

    let fieldsRename = {
      userName : languageValues?.adminDashboard?.monitoringTable?.name[actLanguage],
      certification : languageValues?.adminDashboard?.monitoringTable?.certification[actLanguage],
      nomDiplome : languageValues?.adminDashboard?.monitoringTable?.sector[actLanguage],
      campus : languageValues?.adminDashboard?.monitoringTable?.campus[actLanguage],
      anneeEtude : languageValues?.adminDashboard?.monitoringTable?.studyYear[actLanguage],
      contentType : languageValues?.adminDashboard?.monitoringTable?.moduleType[actLanguage],
      contentName : languageValues?.adminDashboard?.monitoringTable?.module[actLanguage],
      status : languageValues?.adminDashboard?.monitoringTable?.score[actLanguage],
      rattrapage : languageValues?.adminDashboard?.monitoringTable?.rattrapageExport[actLanguage],
      progress : languageValues?.adminDashboard?.monitoringTable?.score[actLanguage]+" (%)",
      scoreGlobale : "Score (%)",
    }
    let fieldsExport = [
      languageValues?.adminDashboard?.monitoringTable?.name[actLanguage],
      languageValues?.adminDashboard?.monitoringTable?.certification[actLanguage],
      languageValues?.adminDashboard?.monitoringTable?.sector[actLanguage],
      languageValues?.adminDashboard?.monitoringTable?.campus[actLanguage],
      languageValues?.adminDashboard?.monitoringTable?.studyYear[actLanguage],
      languageValues?.adminDashboard?.monitoringTable?.moduleType[actLanguage],
      languageValues?.adminDashboard?.monitoringTable?.module[actLanguage],
      languageValues?.adminDashboard?.monitoringTable?.score[actLanguage],
      languageValues?.adminDashboard?.monitoringTable?.rattrapageExport[actLanguage],
      languageValues?.adminDashboard?.monitoringTable?.score[actLanguage]+" (%)",
      "Score (%)",
    ]

    if (actEcole?.campus?.length < 1) {
      delete fieldsRename.campus;
      let index = fieldsExport.indexOf(languageValues?.adminDashboard?.monitoringTable?.campus[actLanguage]);
      if (index > -1) {
        fieldsExport.splice(index, 1);
      }
    }

    if (checkIfHaveRat() === false) {
      delete fieldsRename.rattrapage
      let index = fieldsExport.indexOf(languageValues?.adminDashboard?.monitoringTable?.rattrapageExport[actLanguage]);
      if (index > -1) {
        fieldsExport.splice(index, 1);
      }
    }

    let toAddToExport = JSON.parse(JSON.stringify(filteredData))
    toAddToExport.forEach((res) => {
      if (res.contentType === 'identif') {
        res.contentType = languageValues?.adminDashboard?.contentType?.identif[actLanguage]
      }
      if (res.contentType === 'enrich') {
        res.contentType = languageValues?.adminDashboard?.contentType?.enrich[actLanguage]
      }
      if (res.contentType === 'icebreaker') {
        res.contentType = languageValues?.adminDashboard?.contentType?.icebreaker[actLanguage]
      }

      if (res.status === "notStarted") {
        res.status = languageValues?.adminDashboard?.statusTypes?.notStarted[actLanguage]
      } else if (res.status === "inProgress") {
        res.status = languageValues?.adminDashboard?.statusTypes?.inProgress[actLanguage]
      } else if (res.status === "ended") {
        res.status = languageValues?.adminDashboard?.statusTypes?.ended[actLanguage]
      }

      if (res.endedInRat === true) {
        res.rattrapage = languageValues?.adminDashboard?.monitoringTable?.oui[actLanguage]
      } else {
        res.rattrapage = languageValues?.adminDashboard?.monitoringTable?.non[actLanguage]
      }

      let findGroup = actEcole?.groupes?.find((el) => el.groupeID === res.groupeID)
      let textGroupe = findGroup?.diplome ? findGroup.diplome : "-"
      res.certification = textGroupe
      let findCampus = actEcole?.campus?.find((el) => el.id === res.campusID)
      let textCampus = "-"
      if (findCampus?.name) {
        textCampus = findCampus?.name
      }
      res.campus = textCampus
    })

    let rename = renameKeys(fieldsRename,  toAddToExport);
    let csv = csvFormat(rename, fieldsExport);
    var link = document.createElement('a');
    link.setAttribute('href', 'data:text/csv;charset=utf-8,%EF%BB%BF' + encodeURIComponent(csv));
    link.setAttribute('download', filename+'.csv');
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    addPopupNotif({ uuid : uuidv4(), title : languageValues?.notifExport[actLanguage], type : "confirm", removeAfter : 4000 })  // E6
  }

  const checkIfHaveRat = () => {
    let haveRat = false
    for (let i=0; i<actEcole?.groupes?.length; i++) {
      let g = actEcole?.groupes[i]
      //console.log(g)
      for (let i2=0; i2 < g.plan?.plan?.length; i2++) {
        if (g?.plan?.plan[i2]?.enableRat === true) {
          haveRat = true
        }
      }
    }

    return haveRat
  }

  // Décision d'Hicham (01/09/2026) : la colonne « Année de certification » reste
  // masquée. Elle affichait le niveau de diplôme, ce qui n'a pas de sens, et
  // aucune des trois questions de l'icebreaker ne porte cette information.
  // Passer cette constante à true la réaffichera, une fois une source définie.
  const AFFICHER_ANNEE_CERTIFICATION = false

  // Point 8 de la review du 04/08 : une seule ligne par apprenti, dépliable.
  // Le tableau affichait une ligne par MODULE, soit 3 ou 4 lignes répétées pour
  // la même personne, ce qui le rendait illisible.
  const [apprenantsOuverts, setApprenantsOuverts] = useState({})
  const basculerApprenant = (id) => {
    setApprenantsOuverts((prev) => Object.assign({}, prev, { [id]: !prev[id] }))
  }
  const apprenants = React.useMemo(() => {
    const parUser = new Map()
    filteredData.forEach((ligne) => {
      const cle = ligne.userID
      if (!parUser.has(cle)) parUser.set(cle, { userID: cle, userName: ligne.userName, lignes: [] })
      parUser.get(cle).lignes.push(ligne)
    })
    return Array.from(parUser.values()).map((ap) => {
      const notes = ap.lignes.filter((l) => l.status === "ended" && l.isIcebreakerResult !== true && !isNaN(parseFloat(l.scoreGlobale)))
      return Object.assign(ap, {
        nbrModules: ap.lignes.length,
        nbrTermines: ap.lignes.filter((l) => l.status === "ended").length,
        moyenne: notes.length ? Math.round(notes.reduce((s, l) => s + parseFloat(l.scoreGlobale), 0) / notes.length) : null,
      })
    }).filter((ap) => {
      // E3 : filtre de recherche, insensible a la casse et aux accents
      if (!recherche.trim()) return true
      const plat = (t) => String(t || "").toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "")
      return plat(ap.userName).includes(plat(recherche))
    })
  }, [filteredData, recherche])

  // Point 4 de la review du 04/08 : la colonne Certification ne s'affiche que si
  // au moins un groupe de l'ecole porte une certification renseignee en admin.
  // Relecture 02/09 (bis) : le nombre de pages se calcule sur les apprenants
  // REGROUPES (et filtres par la recherche), pas sur les lignes brutes
  // utilisateur x module : l'ancien calcul affichait des pages vides.
  const nbrPagesApprenants = Math.max(1, Math.ceil(apprenants.length / 25))
  const pageCourante = Math.min(page, nbrPagesApprenants)

  const aUneCertification = Boolean(
    actEcole?.groupes?.some((g) => g?.diplome && String(g.diplome).trim() !== "")
  )

  return (
    <>
      <Hidden smUp>
        <SelectEcoleMenuMobile />
      </Hidden>

      <Box
        sx={{
          flex:1,
          padding:["20px", "50px", "50px", "80px"],
          backgroundColor:"background.grey",
        }}
      >
        <Header
          title={languageValues?.adminDashboard?.monitoring[actLanguage]}
          dataLoaded={dataLoaded && glbData !== null && filteredData.length !== 0}
        />

        <Box sx={{display:"flex", flexWrap:"wrap", gap:["15px","15px","15px","20px"]}}>
          <CardContainer
            title={languageValues?.adminDashboard?.monitoringCards?.students[actLanguage]}
            value={filteredStat.etudiantTot !== undefined ? filteredStat.etudiantTot : "-"} icon={etudiantsTotIcon} dataLoaded={dataLoaded}
          />
          <CardContainer
            title={languageValues?.adminDashboard?.monitoringCards?.modules[actLanguage]}
            value={filteredStat.modules !== undefined ? filteredStat.modules : "-"} icon={modulesIcon} dataLoaded={dataLoaded}
          />
          <CardContainer
            title={languageValues?.adminDashboard?.monitoringCards?.completion[actLanguage]}
            value={filteredStat.tauxCompletion !== undefined ? filteredStat.tauxCompletion : "-"} icon={tauxCompletionIcon} dataLoaded={dataLoaded}
          />
          <CardContainer
            title={languageValues?.adminDashboard?.monitoringCards?.average[actLanguage]} unit="&nbsp;/100"
            value={filteredStat.moyenne !== undefined ? filteredStat.moyenne : "-"} icon={moyenneIcon} dataLoaded={dataLoaded}
          />
          <CardContainer
            title={languageValues?.adminDashboard?.monitoringCards?.softSkills[actLanguage]}
            value={filteredStat.softSkills !== undefined ? filteredStat.softSkills : "-"} icon={softSkillsIcon} dataLoaded={dataLoaded}
          />
          <CardContainer
            title={languageValues?.adminDashboard?.monitoringCards?.time[actLanguage]} unit="&nbsp;MIN"
            value={filteredStat.timing !== undefined ? filteredStat.timing : "-"} icon={moyenneTempsIcon} dataLoaded={dataLoaded}
          />
        </Box>


        {/* E5 review 02/09 : squelette pendant le chargement ; ecran « donnees
            non disponibles » si l'ecole n'a rien a montrer (relecture 02/09) */}
        {!(dataLoaded && glbData !== null) && (
          aucuneDonnee === true ? <NoDataScreen reseau={reseauCoupe} /> : <SkeletonEcran avecTable />
        )}
        {dataLoaded && glbData !== null && filteredStat !== {} &&
          <>
            <Box sx={{
              display:"flex",
              gap:"10px",
              justifyContent:"space-between",
            }}>
              <Box sx={{
                marginTop:"35px",
                display:"flex",
                gap:["8px", "8px", "15px", "15px"],
                flexDirection:["column", "column", "row", "row"],
                alignItems:"flex-start",
              }}>
                <Button
                  ref={popoverRef}
                  disabled={!dataLoaded}
                  variant="contained"
                  disableRipple
                  sx={{
                    height:"40px !important",
                    minHeight:"40px !important",
                    flexShrink:0,
                    textTransform:"none",
                    background:"white",
                    color:"text.black",
                    boxShadow:"none",
                    border:"1px solid #E7E7E7",
                    fontSize:"14px !important",
                    gap:"8px",
                    '&:hover': {
                      background:"white",
                      border:"1px solid black",
                    },
                  }}
                  onClick={() => { setPopoverFilters(true) }}
                >
                  <img src={searchIcon} style={{width:"14px"}} />
                  <span>
                    {languageValues?.adminDashboard?.filters?.addFilter[actLanguage]}
                  </span>
                </Button>
                {/* D9 review 02/09 : deroulants en ligne sur grand ecran,
                    conformes au Figma (Module, Type de module, Annee d'etude,
                    Status). Le bouton garde l'acces aux filtres secondaires. */}
                <Hidden mdDown>
                  <FiltresInline
                    filters={filters} setFilters={setFilters}
                    menus={[
                      { cle:"nom", titre: languageValues?.adminDashboard?.filters?.moduleName[actLanguage], sousTitre: languageValues?.adminDashboard?.filters?.moduleNameSub[actLanguage], datas: glbData.contents, dataToDisplay:"name", dataToCheck:"id", filterType:"moduleIDs" },
                      { cle:"type", titre: languageValues?.adminDashboard?.filters?.moduleType[actLanguage], sousTitre: languageValues?.adminDashboard?.filters?.moduleTypeSub[actLanguage], datas: contentsTypes, filterType:"moduleTypes" },
                      /* S1 (retours Nawal V3, 03/09) : ce filtre compare `anneeEtude`, qui contient
                         la reponse a « quelle est ton annee d'etude ? » (« 1er annee »...), et on lui
                         donnait la liste des reponses DIPLOME (« Master », « Diplome d'ingenieur »...).
                         Choisir « Diplome d'ingenieur » ne pouvait donc jamais rien renvoyer. On lui
                         passe les bonnes reponses. Cf JOURNAL-DES-ERREURS.md, motif M16. */
                      ...(actEcole?.icebreakerQuestions?.annees === true ? [{ cle:"annees", titre: languageValues?.adminDashboard?.filters?.studyYear[actLanguage], sousTitre: languageValues?.adminDashboard?.filters?.studyYearSub[actLanguage], datas: actEcole?.icebreakerQuestions?.anneesReps || [], filterType:"anneesEtude" }] : []),
                      { cle:"status", titre: languageValues?.adminDashboard?.filters?.status[actLanguage], sousTitre: languageValues?.adminDashboard?.filters?.statusSub[actLanguage], datas: statusTypes, filterType:"status" },
                    ]}
                  />
                </Hidden>
                {/* E3 review 02/09 : retrouver un apprenant rapidement */}
                <Box sx={{
                  display:"flex", alignItems:"center", gap:"8px",
                  height:"40px", background:"white",
                  border:"1px solid #E7E7E7", padding:"0 12px",
                  borderRadius:"4px",
                }}>
                  <img src={searchIcon} style={{width:"14px"}} />
                  <input
                    value={recherche}
                    onChange={(e) => { setRecherche(e.target.value); setPage(1) }}
                    placeholder={languageValues?.adminDashboard?.rechercheApprenant?.[actLanguage]}
                    style={{ border:"none", outline:"none", fontSize:"14px", fontFamily:"Questrial", width:"170px", background:"transparent" }}
                  />
                </Box>
                <FiltersDisplay filters={filters} setFilters={setFilters} contents={glbData.contents} defaultF={defautFilters}/>
              </Box>
              <Button
                disabled={!dataLoaded}
                variant="contained"
                disableRipple
                sx={{
                  marginTop:"35px",
                  height:"40px !important",
                  minHeight:"40px !important",
                  flexShrink:0,
                  textTransform:"none",
                  background:"white",
                  color:"text.black",
                  boxShadow:"none",
                  border:"1px solid #E7E7E7",
                  fontSize:"14px !important",
                  gap:"8px",
                  minWidth:"0 !important",
                  '&:hover': {
                    background:"white",
                    border:"1px solid black",
                  },
                }}
                onClick={() => { handleExport() }}
              >
                <img src={exportIcon} style={{width:"15px"}} />
                <Hidden mdDown>
                  <span>
                    {languageValues?.adminDashboard?.exportTable[actLanguage]}
                  </span>
                </Hidden>
              </Button>

            </Box>

            {/* S2 (fiche V3 de Nawal, 03/09) : la largeur du tableau bougeait
                d'un a dix pixels par colonne des qu'on activait un filtre.
                Deux causes, cumulees :
                  - `minWidth: 100%` laisse le tableau DEPASSER son conteneur si
                    le contenu l'exige, donc sa largeur suit son contenu ;
                  - `table-layout: auto` (le defaut) calcule chaque colonne sur
                    le texte le plus long qu'elle contient. Filtrer change les
                    lignes affichees, donc le texte le plus long, donc toutes
                    les largeurs. Mesure avant correctif sur CFA SACLAY DEMO,
                    filtre « Termine » : Nom -2,33 px, Statut +9,59 px.
                `table-layout: fixed` + une largeur par colonne rendent la mise
                en page independante du contenu. Ces largeurs sont RELATIVES
                (voir LARGEUR_COL plus haut) : le navigateur les renormalise sur
                le jeu de colonnes reellement rendu, qui varie d'une ecole a
                l'autre. Aucune colonne ne peut donc tomber a zero, ce qui
                arrivait a « Nom » quand elle etait seule sans largeur. */}
            <TableContainer sx={{marginTop:"25px"}}>
              <Table
                sx={{ width: '100%', tableLayout: 'fixed' }}
              >
                <TableHead>
                  <TableRow sx={{
                    background: "#FAF8F6",
                    '& th': {
                      color:"text.subTitle",
                      fontSize:"15px",
                      border:"1px solid #E7E7E7"
                    }
                  }}>
                    <TableCell align="left" sx={{padding:"10px 16px", width: LARGEUR_COL.nom}}>
                      {languageValues?.adminDashboard?.monitoringTable?.name[actLanguage]}
                    </TableCell>
                    <Hidden mdDown>
                      {/* Point 4 de la review du 04/08 : la colonne Certification
                          etait la seule affichee sans condition, et sa cellule
                          retombait sur le nom du groupe quand le champ etait vide
                          en admin. Elle n'apparait plus que si au moins un groupe
                          de l'ecole a une certification renseignee. */}
                      {aUneCertification &&
                        <TableCell align="left" sx={{padding:"10px 16px", width: LARGEUR_COL.certification}}>
                          {languageValues?.adminDashboard?.monitoringTable?.certification[actLanguage]}
                        </TableCell>
                      }
                      {actEcole?.icebreakerQuestions?.diplome === true &&
                        <TableCell align="left" sx={{padding:"10px 16px", width: LARGEUR_COL.nomDiplome}}>
                          {languageValues?.adminDashboard?.monitoringTable?.sector[actLanguage]}
                        </TableCell>
                      }
                      {actEcole?.campus?.length > 1 &&
                        <TableCell align="left" sx={{padding:"10px 16px", width: LARGEUR_COL.campus}}>
                          {languageValues?.adminDashboard?.monitoringTable?.campus[actLanguage]}
                        </TableCell>
                      }
                      {/* Colonne « Annee de certification » masquee : elle etait
                          alimentee par le niveau de diplome, ce qui n'a pas de
                          sens. Aucune des 3 questions de l'icebreaker ne porte
                          une annee de certification -> a arbitrer avec Nawal. */}
                      {AFFICHER_ANNEE_CERTIFICATION &&
                        <TableCell align="left" sx={{padding:"10px 16px", width: LARGEUR_COL.anneeCertif}}>
                          {languageValues?.adminDashboard?.monitoringTable?.graduationYear[actLanguage]}
                        </TableCell>
                      }
                      {actEcole?.icebreakerQuestions?.annees === true &&
                        <TableCell align="left" sx={{padding:"10px 16px", width: LARGEUR_COL.anneeEtude}}>
                          {languageValues?.adminDashboard?.monitoringTable?.studyYear[actLanguage]}
                        </TableCell>
                      }
                    </Hidden>
                    <Hidden smDown>
                      <TableCell align="left" sx={{padding:"10px 16px", width: LARGEUR_COL.typeModule}}>
                        {languageValues?.adminDashboard?.monitoringTable?.moduleType[actLanguage]}
                      </TableCell>
                    </Hidden>
                    <TableCell align="left" sx={{padding:"10px 16px", width: LARGEUR_COL.module}}>
                      {languageValues?.adminDashboard?.monitoringTable?.module[actLanguage]}
                    </TableCell>
                    <TableCell align="left" sx={{padding:"10px 16px", width: LARGEUR_COL.statut}}>
                      {languageValues?.adminDashboard?.monitoringTable?.score[actLanguage]}
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                {apprenants.slice(
                  (pageCourante-1) * 25,
                  ((pageCourante-1) * 25) + 25
                ).map((apprenant) => {
                  const ouvert = Boolean(apprenantsOuverts[apprenant.userID])
                  const premiere = apprenant.lignes[0] || {}
                  const grpApprenant = actEcole?.groupes?.find((el) => el.groupeID === premiere.groupeID)
                  const certifApprenant = grpApprenant?.diplome ? grpApprenant.diplome : "-"
                  const campusApprenant = actEcole?.campus?.find((el) => el.id === premiere.campusID)?.name || "-"
                  return (
                  <React.Fragment key={apprenant.userID}>
                    <TableRow
                      onClick={() => basculerApprenant(apprenant.userID)}
                      sx={{
                        background: ouvert ? "#FAF8F6" : "white",
                        cursor: "pointer",
                        '&:hover': { background: "#FAF8F6" },
                        '& td': { border: "1px solid #E7E7E7" },
                      }}
                    >
                      <TableCell sx={{fontSize:"13px", color:"text.black", textTransform:"capitalize"}}>
                        <Box sx={{display:"flex", alignItems:"center", gap:"8px"}}>
                          <Box component="span" sx={{
                            display:"inline-block", width:"14px", textAlign:"center",
                            transform: ouvert ? "rotate(90deg)" : "none",
                            transition:"transform 0.15s", color:"#545455", fontSize:"10px",
                          }}>{'\u25B6'}</Box>
                          {apprenant.userName}
                        </Box>
                      </TableCell>
                      <Hidden mdDown>
                        {aUneCertification &&
                          <TableCell sx={{fontSize:"13px", color:"text.black"}}>{certifApprenant}</TableCell>
                        }
                        {actEcole?.icebreakerQuestions?.diplome === true &&
                          <TableCell sx={{fontSize:"13px", color:"text.black"}}>{premiere.nomDiplome ? premiere.nomDiplome : "-"}</TableCell>
                        }
                        {actEcole?.campus?.length > 1 &&
                          <TableCell sx={{fontSize:"13px", color:"text.black"}}>{campusApprenant}</TableCell>
                        }
                        {/* Motif B4 (en-tete desaligne du corps) : cette cellule
                            manquait. L'en-tete et les lignes DEPLIEES portaient
                            toutes deux la colonne « Annee de certification », pas
                            la ligne de synthese. Le decalage ne se voit pas tant
                            que AFFICHER_ANNEE_CERTIFICATION vaut false, mais le
                            jour ou la colonne est reactivee, chaque libelle de
                            l'en-tete surplombe la mauvaise colonne — exactement
                            le defaut deja corrige dans Certification.js. */}
                        {AFFICHER_ANNEE_CERTIFICATION &&
                          <TableCell sx={{fontSize:"13px", color:"text.black"}}>{"-"}</TableCell>
                        }
                        {actEcole?.icebreakerQuestions?.annees === true &&
                          <TableCell sx={{fontSize:"13px", color:"text.black"}}>{premiere.anneeEtude ? premiere.anneeEtude : "-"}</TableCell>
                        }
                      </Hidden>
                      <Hidden smDown>
                        <TableCell sx={{fontSize:"13px", color:"text.subTitle"}}>{'\u2014'}</TableCell>
                      </Hidden>
                      <TableCell sx={{fontSize:"13px", color:"text.subTitle"}}>
                        {apprenant.nbrTermines}{'/'}{apprenant.nbrModules}{' '}
                        {apprenant.nbrModules > 1 ? 'modules' : 'module'}
                      </TableCell>
                      {/* F9 (retours Hicham 03/09) : ce `fontWeight:600` ne
                          s'appliquait qu'aux apprenants ayant tout termine, la
                          branche « Complete a X % » retombant en 400. Deux graisses
                          coexistaient donc dans la meme colonne. Une seule graisse,
                          la normale, pour tous les scores. */}
                      <TableCell sx={{fontSize:"13px", color:"text.black"}}>
                        {/* D1 review 02/09 : indicateur visuel au lieu de la valeur nue.
                            Score valide (tout est termine) : coche verte + « X/100 ».
                            Sinon : rond de progression + « Complete a X % ». */}
                        {(apprenant.nbrTermines === apprenant.nbrModules && apprenant.moyenne !== null) ? (
                          <Box sx={{display:"flex", alignItems:"center", gap:"6px", whiteSpace:"nowrap"}}>
                            <img src={checkGreenRoundIcon} style={{width:"18px"}} alt=""/>
                            {apprenant.moyenne}/100
                          </Box>
                        ) : (
                          <Box sx={{display:"flex", alignItems:"center", gap:"6px", whiteSpace:"nowrap"}}>
                            <RondProgression pct={apprenant.nbrModules > 0 ? Math.round(apprenant.nbrTermines / apprenant.nbrModules * 100) : 0} />
                            {(languageValues?.adminDashboard?.monitoringTable?.completeA?.[actLanguage] || "")
                              .replace("{pct}", apprenant.nbrModules > 0 ? Math.round(apprenant.nbrTermines / apprenant.nbrModules * 100) : 0)}
                          </Box>
                        )}
                      </TableCell>
                    </TableRow>
                    {ouvert && apprenant.lignes.map((row, index) => {
                  let findGroup = actEcole?.groupes?.find((el) => el.groupeID === row.groupeID)
                  let textGroupe = findGroup?.diplome ? findGroup.diplome : "-"
                  let findCampus = actEcole?.campus?.find((el) => el.id === row.campusID)
                  let textCampus = "-"
                  if (findCampus?.name) {
                    textCampus = findCampus?.name
                  }
                  return (
                    <TableRow
                      key={index}
                      sx={{
                        background : "white",
                        '& td': {
                          border:"1px solid #E7E7E7",
                        }
                      }}
                    >
                      {/* A5 review 02/09 : ne pas repeter le nom de l'apprenant
                          sur chaque ligne depliee, il est deja sur la ligne parent */}
                      <TableCell sx={{fontSize:"13px", color:"text.black"}}>
                      </TableCell>
                      <Hidden mdDown>
                        {aUneCertification &&
                          <TableCell sx={{fontSize:"13px", color:"text.black"}}>
                            {textGroupe}
                          </TableCell>
                        }
                        {actEcole?.icebreakerQuestions?.diplome === true &&
                          <TableCell sx={{fontSize:"13px", color:"text.black"}}>
                            {row.nomDiplome ? row.nomDiplome : "-"}
                          </TableCell>
                        }
                        {actEcole?.campus?.length > 1 &&
                          <TableCell sx={{fontSize:"13px", color:"text.black"}}>
                            {textCampus}
                          </TableCell>
                        }
                        {AFFICHER_ANNEE_CERTIFICATION &&
                          <TableCell sx={{fontSize:"13px", color:"text.black"}}>
                            {"-"}
                          </TableCell>
                        }
                        {actEcole?.icebreakerQuestions?.annees === true &&
                          <TableCell sx={{fontSize:"13px", color:"text.black"}}>
                            {row.anneeEtude ? row.anneeEtude : "-"}
                          </TableCell>
                        }
                      </Hidden>
                      <Hidden smDown>
                        <TableCell sx={{fontSize:"13px", color:"text.black"}}>
                          {row.contentType === 'identif' &&
                            languageValues?.adminDashboard?.contentType?.identif[actLanguage]
                          }
                          {row.contentType === 'enrich' &&
                            languageValues?.adminDashboard?.contentType?.enrich[actLanguage]
                          }
                          {row.contentType === 'icebreaker' &&
                            languageValues?.adminDashboard?.contentType?.icebreaker[actLanguage]
                          }
                        </TableCell>
                      </Hidden>
                      <TableCell sx={{fontSize:"13px", color:"text.black"}}>
                        {row.contentName}
                      </TableCell>
                      <TableCell sx={{fontSize:"13px", color:"text.black"}}>
                        {row.status === "ended" &&
                          <Box sx={{display:"flex", gap:"6px", height:"100%", whiteSpace:"nowrap"}}>
                            <img src={checkGreenRoundIcon} style={{width:"18px"}}/>
                            {row.isIcebreakerResult !== true &&
                              <Box>
                                {row.scoreGlobale}
                                <Hidden mdDown>
                                  <font>
                                  /100
                                  </font>
                                </Hidden>
                                <Hidden mdUp>
                                  <font style={{fontSize:"9px"}}>
                                  /100
                                  </font>
                                </Hidden>
                                {row.endedInRat === true && languageValues?.adminDashboard?.monitoringTable?.rattrapage[actLanguage]}
                              </Box>
                            }
                            {row.isIcebreakerResult === true &&
                              <Box>
                                <Hidden mdDown>
                                  {languageValues?.adminDashboard?.monitoringTable?.statusEnded[actLanguage]}
                                </Hidden>
                                <Hidden mdUp>
                                  <font style={{fontSize:"9px"}}>
                                    {languageValues?.adminDashboard?.monitoringTable?.statusEnded[actLanguage]}
                                  </font>
                                </Hidden>
                              </Box>
                            }
                          </Box>
                        }
                        {row.status === "inProgress" &&
                          <Box sx={{display:"flex", gap:"6px", height:"100%"}}>
                            <Box sx={{position:"relative"}}>
                              <CircularProgress variant="determinate" value={100} thickness={5.5} size="18px" sx={{color: '#E7E7E7'}} />
                              <CircularProgress
                                variant="determinate"
                                value={row.progress}
                                thickness={6}
                                size="18px"
                                sx={{
                                  color: "black",
                                  position: 'absolute',
                                  left: 0,
                                }}
                              />
                            </Box>
                            <Box>
                              <Hidden mdDown>
                                {languageValues?.adminDashboard?.monitoringTable?.statusProgress[actLanguage]}
                                {row.progress}%
                              </Hidden>
                              <Hidden mdUp>
                                {row.progress}%
                              </Hidden>
                            </Box>
                          </Box>
                        }
                        {row.status === "notStarted" &&
                          <Box sx={{display:"flex", gap:"6px", height:"100%"}}>
                            <Box sx={{position:"relative"}}>
                              <img src={sablierIcon} style={{height:"18px", marginLeft:"3px"}} />
                            </Box>
                            <Box>
                              <Hidden mdDown>
                                {languageValues?.adminDashboard?.monitoringTable?.statusNotStarted[actLanguage]}
                              </Hidden>
                              <Hidden mdUp>
                                {row.progress}%
                              </Hidden>
                            </Box>
                          </Box>
                        }
                      </TableCell>
                    </TableRow>
                  )
                })}
                  </React.Fragment>
                  )
                })}
                </TableBody>
              </Table>
            </TableContainer>

            <Pagination
              sx={{
                display:"flex",
                justifyContent:"center",
                marginTop:"20px",
                userSelect:"none",
                '& .MuiPaginationItem-root' : {
                  color:"text.subTitle",
                },
                '& .MuiPaginationItem-root.MuiButtonBase-root' : {
                  background:"white",
                  border:"1px solid #E7E7E7",
                  color: "text.subTitle",
                  borderRadius:"0 !important",
                },
                '& .MuiPaginationItem-root.MuiButtonBase-root.Mui-selected' : {
                  background:"white",
                  border:"1px solid #E7E7E7",
                  color: "text.black",
                },
                '& .MuiPaginationItem-root.MuiButtonBase-root:hover' : {
                  background:"white",
                  color: "text.black",
                  border:"1px solid black",
                },
              }}
              siblingCount={0}
              boundaryCount={1}
              count={nbrPagesApprenants}
              page={pageCourante}
              shape="rounded"
              onChange={(e, page) => {
                if (page) {
                  setPage(page)
                  if (popoverRef && popoverRef.current) {
                    popoverRef.current.scrollIntoView()
                  }
                }
              }}
            />

            <Box sx={{
              display:"flex",
              justifyContent:"center",
              marginTop:"15px",
              color:"text.subTitle",
              fontSize:'13px',
            }}>
              {/* ⛔ Ce compteur comptait `filteredData`, c'est-a-dire une ligne
                  par APPRENANT x MODULE, alors que le tableau et la pagination
                  juste au-dessus comptent des APPRENANTS regroupes. Sur la demo
                  Saclay il annoncait « 1-25 sur 5000 » pour 1250 apprenants et
                  50 pages : le client lisait quatre fois l'effectif reel. Il
                  ignorait aussi la barre de recherche, qui ne touche que
                  `apprenants`. Le jumeau de l'ecran Certification avait ete
                  corrige, pas celui-ci.
                  `page` etait de surcroit la variable de l'evenement de la
                  pagination, pas l'etat courant : la plage restait figee quand
                  la liste retrecissait. */}
              {apprenants.length === 0 ? 0 : ((pageCourante-1) * 25) + 1}
              {'-'}
              {((pageCourante-1) * 25) + 25 > apprenants.length ? apprenants.length : ((pageCourante-1) * 25) + 25}
              {' '}{languageValues?.adminDashboard?.paginationSur?.[actLanguage] || 'sur'}{' '}
              {apprenants.length}
            </Box>


            <MyPopover
              isDrawerOpen={popoverFilters}
              anchorEl={popoverRef.current}
              handleClose={() => { setPopoverFilters(false) }}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "left",
              }}
              transformOrigin={{
                vertical: "top",
                horizontal: "left",
              }}
            >
              <ActionList
                glbData={glbData}
                filters={filters}
                setFilters={setFilters}
                icebreakerQuestions={actEcole?.icebreakerQuestions}
              />
            </MyPopover>

          </>
        }

      </Box>

    </>
  )
}


export default Suivi
